import React from 'react'
import iconSecure from '../images/icon-secure.svg'

interface SecureDataTransferProps {
  className?: string
}

const SecureDataTransfer: React.FC<SecureDataTransferProps> = ({ className }) => {
  return (
    <div className={`inline-grid items-center text-green-600 font-bold text-xs pl-2.5 whitespace-nowrap relative top-0.5 ${className || ''}`}>
      <div className="flex items-center">
        <img src={iconSecure} alt="Secure Data Transfer" className="w-[17px] -mt-0.5 mr-1.5" />
        <span>Secure Data Transfer</span>
      </div>
    </div>
  )
}

export default SecureDataTransfer
